import { translate } from '@jsverse/transloco';
export enum AdHocTaskPurpose {
    ADD_INFO = 'ADD_INFO',
    REMEDIATION = 'REMEDIATION',
    ASSISTANCE = 'ASSISTANCE',
    ESCALATION = 'ESCALATION',
    SCOPE_CHANGE = 'SCOPE_CHANGE',
    OTHER = 'OTHER',
}

export class AdHocTaskPurposeHelper {
    static getAdHocTaskPurposeLocale(purpose: AdHocTaskPurpose): string {
        switch (purpose) {
            case AdHocTaskPurpose.ADD_INFO:
                return translate('CORE.AD_HOC_TASK.PURPOSE.ADDITIONAL_INFO');
            case AdHocTaskPurpose.REMEDIATION:
                return translate('CORE.AD_HOC_TASK.PURPOSE.REMEDIATION');
            case AdHocTaskPurpose.ASSISTANCE:
                return translate('CORE.AD_HOC_TASK.PURPOSE.ASSISTANCE');
            case AdHocTaskPurpose.ESCALATION:
                return translate('CORE.AD_HOC_TASK.PURPOSE.ESCALATION');
            case AdHocTaskPurpose.SCOPE_CHANGE:
                return translate('CORE.AD_HOC_TASK.PURPOSE.SCOPE_CHANGE');
            case AdHocTaskPurpose.OTHER:
                return translate('CORE.AD_HOC_TASK.PURPOSE.OTHER');
            default:
                return purpose;
        }
    }
}
